import API_URL from '../config';
import axios from 'axios';

import { getCookie } from './../utils/cookies';

export const getAllPrevisionApi = async() => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/rapport/getAllPrevisionTableData/${id}/${iv}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const oneUserPrevisionsApi = async (tcpId, productsData) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const bodyObject = {
            bodyObject: productsData
        } 

        const res = await axios.post(`${API_URL}/api/rapport/getOneUserPrevisionTableData/${id}/${iv}/${tcpId}`, bodyObject, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const oneUserPrevisionsReportApi = async (reportId) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/rapport/getOnePrevisionAdminDetails/${id}/${iv}/${reportId}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const updatePrevisionApi = async(reportId, reportObject) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const objectData = {
            reportObject: reportObject
        }

        const res = await axios.put(`${API_URL}/api/rapport/updatePrevisionData/${id}/${iv}/${reportId}`, objectData, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const deletePrevisionApi = async(depotId) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.delete(`${API_URL}/api/rapport/deleteOnePrevision/${id}/${iv}/${depotId}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const downloadPrevisionApi = async (tcpId, productsData, year) => {
    try {
        // const res = await axios.post(`${API_URL}/api/rapport/downloadPrevisionRapport`, object);
        // return  `${API_URL}/${res.data}`

        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const bodyObject = {
            bodyObject: productsData
        } 

        const res = await axios.post(`${API_URL}/api/rapport/downloadPrevisionRapport2/${id}/${iv}/${tcpId}?selectedYear=${year}`, bodyObject, option);
        return  `${API_URL}/${res.data}`
    }
    catch (error) {
        throw error
    }
}

export const downloadPrevisionPDFApi = async (forValue, year, productsDetails) => {
    try {
        // Include year in URL if provided, otherwise use current year
        const targetYear = year || new Date().getFullYear();
        // return `${API_URL}/api/rapport/downloadPrevisionRapportPDF/${forValue}/${targetYear}`

        const res = await axios.post(`${API_URL}/api/rapport/downloadPrevisionRapportPDF/${encodeURIComponent(forValue)}/${encodeURIComponent(targetYear)}`,
        {
            data: productsDetails
        }, {
            responseType: 'blob',
            headers: {
                Accept: 'application/pdf'
            }
        });

        const blob = new Blob([res.data], { type: 'application/pdf' });
        const fileName = `Rapport_Prevision_${targetYear}.pdf`;

        // Create object URL for the blob
        const blobUrl = URL.createObjectURL(blob);
        return blobUrl
    }
    catch (err) {
        throw err
    }
}

// /previsionValidation/:adminID/:myIV/:reportId

export const handlePrevisionValidationApi = async (reportId, status) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const bodyObject = {
            status: status
        } 

        const res = await axios.put(`${API_URL}/api/rapport/previsionValidation/${id}/${iv}/${reportId}`, bodyObject, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}
